/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate, useParams, Link } from 'react-router-dom'
import ReactHtmlParser from 'react-html-parser'

import blackDottedSpinnerGIF from '../../../../assets/dotted-black-trans-spinner-200.gif'
import turquoiseDottedSpinnerGIF from '../../../../assets/dotted-turquoise-trans-spinner-200.gif'
import whiteDottedSpinnerGIF from '../../../../assets/dotted-white-trans-spinner-200.gif'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { navbarHeight, footerHeigh, oneTestRate } from '../../../../helpers/variableDefaults'
import { standardButton } from '../../../../helpers/buttons'
import { descriptionTextField } from '../../../../helpers/textfields'
import { standardErrorContainer } from '../../../../helpers/errors'
import { standardSpinner } from '../../../../helpers/spinners'
import useWindowDimensions from '../../../../helpers/windowDimensions'
import { advisoryTypography } from '../../../../helpers/typographies'
import { getTokenFromLocalStorage, userIsAuthenticated } from '../../../../helpers/storage'

import { seoPageTags, customAnalyticsEvent } from '../../../../helpers/analytics'

// Stripe
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js'
import { paymentDetailsJSX } from './paymentDetailsJSX'

// VC Sim Payment
const Payment = (props) => {

  // Window Dimensions
  const { height, width } = useWindowDimensions()

  const { stripePaymentForm, setStripePaymentForm, vcSimulation, setVCSimulation, setHasPaidForResults, loading, setLoading } = props
  // console.log('vcSimulation._id ->', vcSimulation._id)

  // Stripe
  const stripe = useStripe()
  const elements = useElements()

  // Payment States
  const [paymentMethodString, setPaymentMethodString] = useState('card')

  // Loading
  const [loadingPayment, setLoadingPayment] = useState(false)
  const [loadingSubmit, setLoadingSubmit] = useState(false)

  // const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState(false)
  const [paymentErrors, setPaymentErrors] = useState({ })
  const [errorsSubmit, setErrorsSubmit] = useState(false)

  const [submitSuccessful, setSubmitSuccessful] = useState(false)

  useEffect(() => {
    // console.log('value ->', value)
  }, [paymentMethodString, loadingPayment, loadingSubmit, paymentErrors, errorsSubmit])

  const handlePaymentElementChange = (e) => {
    // console.log('handlePaymentElementChange runs')
    // console.log('handlePaymentElementChange event ->', e)

    // setPaymentErrors({ message: 'testing' })
    setPaymentErrors({ })

    if ('value' in e && 'type' in e.value && e.value.type !== paymentMethodString) {
      
      setPaymentMethodString(e.value.type)
    }

    if (e.complete !== stripePaymentForm.paymentMethodIsValid) {

      setStripePaymentForm({ ...stripePaymentForm, paymentMethodIsValid: e.complete })

    } 
  }

  const handleSubmitPaymentPressed = async () => {
    console.log('handleSubmitPaymentPressed')

    try {
      setLoadingPayment(true)
      setLoadingSubmit(true)
      setErrorsSubmit(false)

      // Handle Payment
      // Stripe — Trigger form validation and wallet collection
      const { error: submitError } = await elements.submit()
      if (submitError) {
        // setRegisterErrors(false)
        setPaymentErrors(submitError)
        setLoadingPayment(false)
        return
      }

      const formToUpload = { ...stripePaymentForm }

      try {
        const { data } = await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/create-payment-intent-single-test/`, formToUpload, {
          headers: {
            Authorization: userIsAuthenticated() ? `Bearer ${getTokenFromLocalStorage()}` : 'Guest',
          },
        })
        // console.log('data ->', data)
        // console.log('data.clientSecret ->', data.clientSecret)
        // console.log('data.customerId ->', data.customerId)

        const clientSecret = data.clientSecret
        const customerId = data.customerId
        // console.log('elements ->', elements)
        // console.log('cardElement ->', cardElement)
        // console.log('stripe ->', stripe)
  
        const { error: confirmPaymentError } = await stripe.confirmPayment({
          elements,
          clientSecret,
          confirmParams: {
            return_url: `${process.env.REACT_APP_CLIENT_URL}/`,
          },
          redirect: 'if_required',
        })
        // console.log('confirmPaymentError ->', confirmPaymentError)

        if (confirmPaymentError) {
          console.log('confirm payment error')

          setErrorsSubmit(false)
          setPaymentErrors(confirmPaymentError)
          setLoadingPayment(false)
          setLoadingSubmit(false)
        } else {
          console.log('everything runs successfully, now you can change hasPaidForResults to true')
          
          // Create the Profile Review Here
          // objectToUpload.stripeCustomerId = customerId

    
          const objectToUpload = {
            hasPaidForResults: true,
            stripeCustomerId: customerId,
          }
          // objectToUpload.subscriptionIsActive = true
          // console.log('vcSimulation._id ->', vcSimulation._id)

          try {
            await axios.put(`${process.env.REACT_APP_SERVER_URL}/api/vc-simulations/${vcSimulation._id}`, objectToUpload, {
              headers: {
                Authorization: `Bearer ${getTokenFromLocalStorage()}`,
              },
            })

            setVCSimulation({
              ...vcSimulation,
              hasPaidForResults: true,
            })
            setHasPaidForResults(true)


            // Update States
            setSubmitSuccessful(true)
            setErrorsSubmit(false)
            setLoadingSubmit(false)
            setPaymentErrors({})
            setLoadingPayment(false)
            
          } catch (hasPaidForResultsUploadError) {
            console.log('hasPaidForResults upload error ->', hasPaidForResultsUploadError)

            // Update States
            setErrorsSubmit(true)
            setLoadingSubmit(false)
            setPaymentErrors({})
            setLoadingPayment(false)
          }
        }


      } catch (paymentIntentError) {
        console.log('Payment Intent Error ->', paymentIntentError)
        setErrorsSubmit(false)
        setLoadingSubmit(false)
        setPaymentErrors({ message: 'Payment Processing Errors' })
        setLoadingPayment(false)
      }

    } catch (err) {
      console.log('submit review request error ->', err)

      setLoadingPayment(false)
      setPaymentErrors({ message: 'Payment Method Errors' })
      setErrorsSubmit(false)
      setLoadingSubmit(false)
    }
  }

  const summaryJSX = () => {
    return (
      <Box
        sx={{
          my: 1,
          p: 2,
          backgroundColor: 'whitesmoke',
          width: '100%',
          boxShadow: 3,
          borderRadius: '5px',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        {/* Title, Advisory */}
        <Typography
          sx={{
            fontWeight: 'bold',
            fontSize: '18',
          }}
        >
          Summary
        </Typography>

        {/* Payment Summary (Product Purchased, Price) */}
        <Box
          sx={{
            my: 1,
            p: 2,
            width: '95%',
            maxWidth: '300px',
            backgroundColor: 'white',
            borderRadius: 3,
            border: 2,
            borderColor: 'black',
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
          }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
            }}
          >
            <Typography>
              {`VC Simulation Results`}
            </Typography>
            <Typography>
              {/* TK */}
              {
                `$${oneTestRate}`
              }
            </Typography>
          </Box>

        </Box>
      </Box>
    )
  }

  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {seoPageTags(
        'Simulation Payment'
      )}

      {/* Body */}
      <Box 
        sx={{ 
          // height: `calc(100vh - ${navbarHeight} - ${footerHeight})`, 
          // height: '100vh',
          // backgroundColor: 'pink',
          width: '100%', 
          py: 5,
          display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start', 
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: '600px',
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', 
          }}
        >
          {/* Title  */}
          <Typography
            sx={{
              fontWeight: 'bold',
              fontSize: '18',
            }}
          >
            Payment
          </Typography>
          {advisoryTypography(
            `Viewing results costs $${oneTestRate}`
          )}

          {/* Summary */}
          {summaryJSX()}

          {/* Payment Details */}
          {paymentDetailsJSX(PaymentElement, paymentMethodString, handlePaymentElementChange, stripePaymentForm, setStripePaymentForm, paymentErrors, setPaymentErrors, loadingPayment)}

          {/* Submit Request Button */}
          {!loadingPayment &&
            <Box
              sx={{
                my: 1,
                width: '100%',
                display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              {standardButton(
                'Submit', 
                'button',
                'contained',
                (!(stripePaymentForm.paymentMethodIsValid) || loadingSubmit || ('hasPaidForResults' in vcSimulation && vcSimulation.hasPaidForResults)),
                // loadingSubmit || selectedReviewType.type.length === 0,
                'primary', 
                1,
                0,
                0,
                width > 300 ? '220px' : '95%', 
                '45px', 
                handleSubmitPaymentPressed
              )}

              {/* Advisory */}
              {!loadingPayment 
                && (paymentMethodString === 'card') 
                && (paymentMethodString !== 'card') 
                &&
                <Typography 
                  component='pre'
                  textAlign={'center'}
                  sx={{
                    mb: 0, mt: 1,
                    width: '90%',
                    fontStyle: 'italic',
                    color: 'blue',
                  }}
                >
                  {
                    `*Card will be charged immediately`.replace(/ {4} +/g, '')
                  }
                </Typography>
              }

              {/* Advisory */}
              {!loadingPayment 
                // && (paymentMethodString === 'card') 
                &&
                <Typography 
                  component='pre'
                  textAlign={'center'}
                  sx={{
                    mt: 1, mb: 2,
                    width: '90%',
                    fontStyle: 'italic',
                    color: 'blue',
                  }}
                >
                  
                  {`*Payments processed through Stripe`.replace(/ {4} +/g, '')}
                    
                </Typography>
              }
            </Box>
          }

          {loadingSubmit && 
            advisoryTypography(`Processing Payment...`)
          }

          {errorsSubmit && 
            standardErrorContainer(
              `There was an error with your request. Check your Internet connection and try again`,
              0,
              0
            )
          }
        </Box>
      </Box>
    </>
  )
}

export default Payment